// @flow

import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from '@riseart/common';
import { GridFluid, GridFluidItem } from '@riseart/grid';
import { ActivityCard } from '@riseart/activity';
import { activity as ENUM_ACTIVITY } from 'Enum';
import { store as STORE_CONFIG } from 'Config';
import { WithStore } from 'shared_hocs/connect/withStore';
import { localeSelector } from 'shared_services/redux/selectors/locale';
import { PicturePlaceholder, Picture } from 'shared_components/common/artdirection/picture/Picture';
import { ActivityRendererMapper } from 'shared_services/riseart/utils/ActivityUtils';
import { isRoutedUrl } from 'shared_services/riseart/utils/Utils';

import { activityListCls } from 'shared_components/activity/List.less';

type Props = {
  items: Array<Object>,
  wrapperPaddings: Object,
  isLoading: boolean,
};

export const ActivityList = ({ items, wrapperPaddings }: Props) => {
  const intl = useIntl();

  return (
    <WithStore
      mapStateToProps={(state: Object): Object => {
        return {
          me: state[STORE_CONFIG.keys.me] && state[STORE_CONFIG.keys.me].data,
          locale: localeSelector(state),
        };
      }}
    >
      {({ me, locale }) => (
        <GridFluid
          columnCount="2"
          wrapperPaddings={wrapperPaddings}
          windowWidth={typeof window !== 'undefined' && window.innerWidth}
        >
          {() =>
            items.map((item) => {
              const { id, type } = item || {};
              const renderData =
                (ActivityRendererMapper[type] &&
                  ActivityRendererMapper[type](
                    item,
                    intl.formatMessage,
                    ENUM_ACTIVITY.image.type.TYPE_MASTER,
                    me,
                    null,
                    locale,
                  )) ||
                {};

              if (!renderData.objectTitle) {
                return null;
              }

              const PictureComponent = renderData.objectImage ? (
                <PicturePlaceholder
                  type="activity.gridTwoCol"
                  artDirectionKey={renderData.artDirectionKey}
                  image={renderData.objectImage}
                  alt={renderData.altTitle}
                  lazyload
                />
              ) : null;
              const isObjectUrlRouted =
                renderData.objectImage && renderData.objectUrl && isRoutedUrl(renderData.objectUrl);

              return (
                <GridFluidItem columnCount={2} key={id}>
                  <ActivityCard
                    key={id}
                    className={activityListCls}
                    createdAt={renderData.createdAt}
                    name={renderData.creatorName || ''}
                    {...(renderData.creatorImage
                      ? {
                          avatarImage: (
                            <Picture
                              type="avatar.large"
                              artDirectionKey="common.avatar"
                              image={renderData.creatorImage}
                              alt={renderData.creatorName || ''}
                            />
                          ),
                        }
                      : null)}
                    title={renderData.title}
                  >
                    {renderData.objectImage && renderData.objectUrl ? (
                      <Link
                        external={!isObjectUrlRouted}
                        {...{ [isObjectUrlRouted ? 'to' : 'href']: renderData.objectUrl }}
                        title={renderData.altTitle}
                      >
                        {PictureComponent}
                      </Link>
                    ) : (
                      PictureComponent
                    )}
                  </ActivityCard>
                </GridFluidItem>
              );
            })
          }
        </GridFluid>
      )}
    </WithStore>
  );
};
